import { useEffect, useState } from "react";
import { Flame, Heart } from "lucide-react";
import { api } from "../lib/api";
import { EventCard } from "./EventCard";

export const PopularEvents = ({ favIds, onToggleFavorite }) => {
  const [events, setEvents] = useState([]);

  useEffect(() => {
    api.get("/events/popular", { params: { limit: 4 } }).then((r) => setEvents(r.data)).catch(() => {});
  }, []);

  if (events.length === 0) return null;

  return (
    <section className="max-w-7xl mx-auto px-5 pt-14" data-testid="popular-events-section">
      <div className="flex items-end justify-between gap-4 mb-6">
        <div>
          <div className="overline text-wyd-accent mb-2 flex items-center gap-2"><Flame size={14} /> I più amati</div>
          <h2 className="font-display font-bold text-2xl md:text-3xl">Gli eventi più salvati</h2>
        </div>
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6">
        {events.map((e, i) => (
          <div key={e.id} className="relative">
            <EventCard event={e} index={i} isFavorite={favIds.has(e.id)} onToggleFavorite={onToggleFavorite} />
            <span data-testid={`popular-save-count-${e.id}`}
              className="absolute -top-3 right-14 z-10 flex items-center gap-1 px-3 py-1 rounded-full bg-wyd-bg border border-wyd-accent/50 text-xs font-semibold text-wyd-text">
              <Heart size={12} className="fill-wyd-accent text-wyd-accent" /> {e.save_count}
            </span>
          </div>
        ))}
      </div>
    </section>
  );
};
